import geolocation from "./geolocation";
import appconfig from "../../appconfig";
import { platformDetector } from "../../mobile/platformDetector";

export const sunsetGeolocationHelper = async (self) => {
	// this is to ensure that in any case sorting shops is not stuck
	const timeoutId = setTimeout(() => {
		self.sortingShops = false;
		clearTimeout(timeoutId);
	}, 5000);
	if (isMobileBrowserOnIos()) {
		// without this, mobile browser in ios would not prompt for a location
		// also there are some issues with permissions API when on ios mobile browser, where permissionsCheck() does not return correct status
		// when location is allowed (still returns "prompt" when it should be "granted")
		const onSuccess = (position) => {
			self.sortingShops = true;
			const id = setTimeout(() => {
				clearTimeout(id);
				self.triggerGetAndFillShopDistances.flag = true;
				self.triggerGetAndFillShopDistances.position = position;
			},0);
		};
		const onError = () => {
			self.sortingShops = false;
			self.triggerGetAndFillShopDistances.flag = false;
		};
		return geolocation.watchPositionIosMobileBrowserAsync({onSuccess, onError});
	}

	const status = await geolocation.checkPermissions();
	const stopSortingLoaderAfterPositionRetrieved = (position) => {
		const intervalId = setInterval(() => {
			if (self.sortingShops) {
				self.triggerGetAndFillShopDistances.flag = true;
				self.triggerGetAndFillShopDistances.position = position;
				clearInterval(intervalId);
			}
		}, 100);
	};
	const onError = () => {
		setTimeout(() => {
			self.triggerGetAndFillShopDistances.flag = false;
			self.sortingShops = false;
		}, 500);
	};
	if (status === "prompt") {
		const startSortingLoaderOnceGranted = () => {
			self.sortingShops = true;
		};
		geolocation.checkPermissionsPolling(startSortingLoaderOnceGranted);
		return geolocation.watchPositionAsync({onSuccess: stopSortingLoaderAfterPositionRetrieved, onError});
	}
	if (status === "granted") {
		self.sortingShops = true;
		return geolocation.watchPositionAsync({onSuccess: stopSortingLoaderAfterPositionRetrieved, onError});
	}
};
const isMobileBrowserOnIos = () => {
	return appconfig.mobile.mobileApi().platformId === "web" && platformDetector.isIosMobileDevice();
};
